export const setCookie = (n, v, d) => {
  const date = new Date(); date.setDate(date.getDate() + d)
  document.cookie = `${encodeURIComponent(n)}=${encodeURIComponent(v ?? '')};expires=${date.toUTCString()};path=/`
}
export const getCookie = (n) => {
  const prefix = `${encodeURIComponent(n)}=`
  const item = document.cookie.split('; ').find(row => row.startsWith(prefix))
  if (!item) return ''
  const value = item.slice(prefix.length)
  try {
    return decodeURIComponent(value)
  } catch (e) {
    return value
  }
}
export const delCookie = (n) => setCookie(n, '', -1)
